/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetListingsItemsRequest
 */
export interface RequestGetListingsItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestGetListingsItemsRequest
     */
    pageToken?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestGetListingsItemsRequest
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetListingsItemsRequest
     */
    userId?: number;
}

/**
 * Check if a given object implements the RequestGetListingsItemsRequest interface.
 */
export function instanceOfRequestGetListingsItemsRequest(value: object): value is RequestGetListingsItemsRequest {
    return true;
}

export function RequestGetListingsItemsRequestFromJSON(json: any): RequestGetListingsItemsRequest {
    return RequestGetListingsItemsRequestFromJSONTyped(json, false);
}

export function RequestGetListingsItemsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetListingsItemsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'pageToken': json['page_token'] == null ? undefined : json['page_token'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function RequestGetListingsItemsRequestToJSON(json: any): RequestGetListingsItemsRequest {
    return RequestGetListingsItemsRequestToJSONTyped(json, false);
}

export function RequestGetListingsItemsRequestToJSONTyped(value?: RequestGetListingsItemsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page_token': value['pageToken'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

